import axios from 'axios';
import store from '../store';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export default {
  getActiveSessions() {
    const token = store.getters.token;
    return apiClient.get('/stream/sessions', {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  joinSession(uid: number) {
    const token = store.getters.token;
    return apiClient.post(
      '/stream/join',
      { uid },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  },
  leaveSession(uid: number) {
    const token = store.getters.token;
    return apiClient.post(
      '/stream/leave',
      { uid },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  },
};
